<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-03-04 09:34:16
!-->
<template>
  <div id="index" class="index">
    <div
      v-show="isAddPanle"
      class="mask"
      @click="
        () => {
          isAddPanle = false;
        }
      "
    />
    <div class="shipments">
      <div class="shipments-tab">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          :class="['Company-Details', { active: selectNumber == index }]"
          @click="clickType(item, index)"
        >
          {{ item.title }}({{ item.num }})
        </div>
        <div
          v-if="!isSearch"
          class="search-class"
          @click.stop="
            () => {
              isSearch = true;
            }
          "
        >
          <img src="../../assets/img/manage/search@2x.png" width="20px" height="20px">
        </div>
        <div
          v-show="isSearch"
          v-clickoutside="
            () => {
              isSearch = false;
            }
          "
          :class="{ 'order-search': true, 'order-search-active': inputStatus }"
          @mouseover="
            () => {
              if (searchKey) {
                search_btn = true;
              }
            }
          "
          @mouseout="
            () => {
              if (searchKey) {
                search_btn = false;
              }
            }
          "
        >
          <div
            class="order-search-input"
            @mouseenter="
              () => {
                if (searchKey) {
                  deleteIcon = true;
                }
              }
            "
            @mouseleave="
              () => {
                search_btn = false;
                if (inputStatus && searchKey.length) {
                  deleteIcon = true;
                } else {
                  deleteIcon = false;
                }
              }
            "
          >
            <input
              ref="orderSearchInput"
              v-model="searchKey"
              type="text"
              class="order-search-input__inner"
              :placeholder="'请输入'"
              maxlength="20"
              @focus="focusInput"
              @blur="blurInput"
              @keydown.enter="submitSearch"
            >
            <div
              class="delete-icon"
              @click.stop="
                () => {
                  searchKey = '';
                }
              "
            >
              <transition name="shanchu">
                <img
                  v-show="deleteIcon"
                  src="../../assets/img/manage/del_icon.png"
                  width="16px"
                  height="16px"
                >
              </transition>
            </div>
          </div>
          <div :class="['order-search-btn', search_btn ? 'search_btnhover' : '']" @click="submitSearch">
            <img src="../../assets/img/manage/search@2x.png" width="20px" height="20px">
          </div>
        </div>
      </div>
      <div class="shipments-right-main">
        <div class="shipments-right">
          <div :class="{ 'add-active': isAddPanle }" style="cursor: pointer" @click="clickAdd()">
            添加/删除列
          </div>
          <div style="cursor: pointer" @click="exportBill">导出为CSV</div>
        </div>
        <div v-if="isAddPanle" class="columns-panle">
          <vuedraggable v-model="columeList" class="wrapper" @update="updateSort">
            <template v-for="(item, index) in columeList">
              <div
                :key="index"
                :class="['list-item']"
                style="cursor: pointer"
                @click="activeList(item, index)"
              >
                <div
                  :class="
                    item.isSelected ? 'choose-icon-active' : 'choose-icon'
                  "
                />
                <span>{{ item.value }}</span>
              </div>
            </template>
          </vuedraggable>
        </div>
      </div>
    </div>
    <div class="table-main">
      <Table ref="Table" />
      <div class="flex flex-row-end">
        <!-- <button :class="{ 'default-btn': !isPay, 'active-btn': isPay }">
          <span>支付</span>
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable'
import Table from './Table.vue'
import request from '@/utils/request'
import {
  ExportBill
} from '@/api/user.js'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Table,
    vuedraggable
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isPay: false,
      isSearch: false,
      inputStatus: false, // 输入框状态
      searchKey: '', // 搜索关键词
      search_btn: false,
      deleteIcon: false, // 删除按钮
      isAddPanle: false,
      columeList: [{
        field: 'statusStrCn',
        value: '账单状态',
        isSelected: true,
        sortable: true,
        type: 'input',
        width: 180,
        fixed: false
      },
      {
        field: 'billNo',
        value: '账单号',
        isSelected: true,
        width: 200,
        fixed: false
      },
      {
        field: 'orderName',
        value: '关联订单',
        isSelected: true,
        width: 200,
        fixed: false,
        isLink: true
      },
      {
        field: 'orderNo',
        value: '订单号',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: 'mode',
        value: '运输方式',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: '',
        value: '商品名称',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: 'carrierName',
        value: '承运商',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: 'horder',
        value: 'HAWB / HBOL',
        isSelected: false,
        width: 120,
        fixed: false
      },
      {
        field: 'morder',
        value: 'MAWB / MBOL',
        isSelected: false,
        width: 150,
        fixed: false
      },
      {
        field: 'vessel',
        value: '船只/航班',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: 'container',
        value: '集装箱号',
        isSelected: false,
        width: 150,
        fixed: false
      },
      {
        field: 'billStatusStr',
        value: '订单状态',
        isSelected: false,
        width: 150,
        fixed: false
      },
      {
        field: 'updateTimeStr',
        value: '更新日期',
        isSelected: false,
        width: 200,
        fixed: false
      },
      {
        field: 'creatorTimeStr',
        value: '账单创建时间',
        isSelected: true,
        width: 200,
        fixed: false
      },
      {
        field: 'dueTimeStr',
        value: '截止时间',
        isSelected: true,
        width: 200,
        fixed: false
      },
      {
        field: 'currency',
        value: '币种',
        isSelected: true,
        width: 150,
        fixed: false
      },
      {
        field: 'totalCost',
        value: '账单金额',
        isSelected: true,
        width: 150,
        fixed: false
      },
      {
        field: 'totalPaid',
        value: '已支付',
        isSelected: true,
        width: 150,
        fixed: false
      },
      {
        field: 'totalDue',
        value: '未支付',
        isSelected: true,
        width: 180,
        fixed: false
      }
      ],
      token: '',
      tabList: [{
        title: '待支付',
        num: 0
      },
      {
        title: '已支付',
        num: 0
      },
      {
        title: '全部',
        num: 0
      }
      ],
      selectNumber: 0,
      deatilsPath: '/customer/deatils', // 表格当前行跳转路径
      tableList: [{
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      },
      {
        id: 0,
        name: 'name',
        label: '姓名',
        type: 'text',
        param: '',
        isShow: true,
        exp: '',
        extra: {
          icon: 'file-list-line'
        }
      }
      ]
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getOrderInfo()
      localStorage.setItem(
        'columeList-billing',
        JSON.stringify(this.columeList)
      )
    }
  },
  methods: {
    updateSort() {
      localStorage.removeItem('columeList-billing')
      localStorage.setItem(
        'columeList-billing',
        JSON.stringify(this.columeList)
      )
      this.$nextTick(() => {
        this.$refs.Table.updateSort()
      })
    },
    exportBill() {
      ExportBill({
        status: this.selectNumber + 1,
        keywords: this.searchKey
      }).then((res) => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    clickAdd() {
      this.isAddPanle = true
    },
    activeList(item, index) {
      item.isSelected = !item.isSelected
      localStorage.removeItem('columeList-billing')
      localStorage.setItem(
        'columeList-billing',
        JSON.stringify(this.columeList)
      )
      this.$nextTick(() => {
        this.$refs.Table.updateSort()
      })
    },
    focusInput() {
      this.inputStatus = true
      // 选中文本
      this.$refs.orderSearchInput.select()
      if (this.searchKey.length > 0) {
        this.deleteIcon = true
      }
    },
    blurInput() {
      this.inputStatus = false
      this.deleteIcon = false
    },
    submitSearch() {
      this.searchKey = this.searchKey.trim()
      this.getOrderInfo(this.searchKey)
      this.$nextTick(() => {
        this.$refs.Table.search(this.searchKey)
      })
    },
    // 清除input值
    clearInput() {
      this.searchKey = ''
    },
    clickType(item, index) {
      this.selectNumber = index
      this.$nextTick(() => {
        this.$refs.Table.change(index + 1)
      })
    },
    getOrderInfo(keywords) {
      request({
        url: `/api/fin/FinancialCosts/GetCustomerOrderBillCnCounts`,
        method: 'GET',
        data: {
          keywords: keywords
        },
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.data != null) {
          var unPaied = res.data.find(item => item.value == 1)
          var unPaiedCount = 0
          if (unPaied) {
				 unPaiedCount = unPaied.total
          }
          var paied = res.data.find(item => item.value == 2)
          var paiedCount = 0
          if (paied) {
				 paiedCount = paied.total
          }
          this.tabList[0].num = unPaiedCount
          this.tabList[1].num = paiedCount
          this.tabList[2].num = unPaiedCount + paiedCount
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
	}

	.shipments {
		display: flex;
		justify-content: space-between;

		.shipments-tab {
			display: flex;
			justify-content: start;

			.Company-Details,
			.Users {
				padding: 0 8px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #777777;
				text-align: center;
				font-style: normal;
				margin-right: 16px;
				line-height: 32px;
				cursor: pointer;
				border-radius: 6px;
			}

			.active {
				// max-width: 150px;
				// min-width: 59px;
				white-space: nowrap;
				height: 32px;
				line-height: 32px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 16px;
				text-align: center;
				font-style: normal;
				color: #3370ff !important;
				background: #ffffff;
			}

			.search-class {
				width: 32px;
				height: 32px;
				background: #3370ff;
				border-radius: 8px;
				line-height: 32px;
				color: #ffffff;

				&:hover {
					background: #3370ff;
				}

				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}

			.order-search {
				display: flex;
				align-items: center;
				width: 240px;
				height: 32px;
				padding: 0 3px 0 12px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid #3370ff;
				position: relative;
				box-sizing: border-box;
				transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

				&:hover {
					background: #ffffff;
					transition: all 0.2s;

					.order-search-input .order-search-input__inner {
						background: #ffffff;
						transition: all 0.2s;
					}
				}

				.order-search-input {
					position: relative;

					.order-search-input__inner {
						width: 170px;
						height: 18px;
						padding: 6px 0;
						font-size: 13px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 18px;
						outline: none;
						border: none;

						&::-webkit-input-placeholder {
							font-size: 13px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #aaaaaa;
							line-height: 18px;
						}
					}

					.delete-icon {
						position: absolute;
						width: 20px;
						height: 16px;
						top: 8px;
						right: -20px;
						cursor: pointer;
						z-index: 9999;
						display: flex;
						align-items: center;
					}
				}

				.order-search-btn {
					position: absolute;
					right: 0px;
					width: 32px;
					height: 32px;
					background: #3370ff;
					border-radius: 8px;
					line-height: 32px;
					color: #ffffff;

					&:hover {
						background: #3370ff;
					}

					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}

		.shipments-right-main {
			position: relative;

			.shipments-right {
				float: right;
				display: flex;

				div {
					cursor: pointer;
					height: 32px;
					line-height: 32px !important;
					background: rgba(233, 85, 6, 0);
					border-radius: 8px;
					border: 1px solid #3370ff;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #3370ff;
					line-height: 20px;
					text-align: center;
				}

				.add-active {
					background: rgba(233, 85, 6, 0);
				}

				div:nth-of-type(1) {
					width: 112px;
					margin-right: 16px;
				}

				div:nth-of-type(2) {
					width: 112px;
				}
			}

			.columns-panle {
				width: 200px;
				height: auto;
				background: #ffffff;
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
				border-radius: 8px;
				border: 1px solid rgba(221, 221, 221, 0.56);
				position: absolute;
				z-index: 100;
				top: 35px;
				padding: 6px 0;

				.list-item {
					height: 33px;
					line-height: 33px;
					background: rgba(255, 255, 255, 0);
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 22px;
					text-align: left;
					display: flex;
					align-items: center;
					padding-right: 12px;

					&:hover {
						background: #f2f4f8;

						.img_icon {
							background: url('../../assets/img/manage/settings/a_1.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						&:active {
							background: url('../../assets/img/manage/settings/a_2.jpg');
							width: 16px;
							height: 16px;
							background-size: 16px 16px;
							margin-left: auto;
						}
					}

					.img_icon {
						background: url('../../assets/img/manage/settings/a_1.jpg');
						width: 16px;
						height: 16px;
						background-size: 16px 16px;
						margin-left: auto;
					}

					.choose-icon {
						width: 16px;
						height: 16px;
						background: #ffffff;
						border-radius: 4px;
						border: 1px solid #cccccc;
						margin: 16px 8px 16px 16px;
						box-sizing: border-box;
					}

					.choose-icon-active {
						background: url('../../assets/img/client/check/icon_ic_xp_selected@2x.png');
						background-size: 16px 16px;
						width: 16px;
						height: 16px;
						margin: 16px 8px 16px 16px;
					}
				}
			}
		}
	}

	.table-main {
		background: #ffffff;
		border-radius: 8px;
		padding: 24px;
		margin-top: 16px;

		.default-btn {
			outline: none;
			border: none;
			width: 96px;
			height: 32px;
			background: #a5c0ff;
			border-radius: 8px;
			box-sizing: border-box;

			span {
				display: inline-block;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 14px;
				color: #ffffff;
				line-height: 22px;
				text-align: center;
				font-style: normal;
			}

		}

		.active-btn {
			outline: none;
			border: none;
			width: 96px;
			height: 32px;
			background: #3370ff;
			border-radius: 8px;
			box-sizing: border-box;

			span {
				display: inline-block;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 14px;
				color: #ffffff;
				line-height: 22px;
				text-align: center;
				font-style: normal;
			}

			&:hover {
				cursor: pointer;
			}
		}
	}
</style>
